module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori-cbb2cfe16a0391cad43763de4b8a43b8.webp";